import { render, staticRenderFns } from "./TransferHistory.vue?vue&type=template&id=718891c9&"
import script from "./TransferHistory.js?vue&type=script&lang=js&"
export * from "./TransferHistory.js?vue&type=script&lang=js&"
import style0 from "./TransferHistory.vue?vue&type=style&index=0&id=718891c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports